// extracted by mini-css-extract-plugin
export var bullet = "_sd-q";
export var bulletText = "_sd-p";
export var bullets = "_sd-k";
export var callout = "_sd-g";
export var calloutBody = "_sd-i";
export var calloutLabel = "_sd-h";
export var checkIcon = "_sd-m";
export var checkList = "_sd-j";
export var checkSvg = "_sd-n";
export var checkText = "_sd-o";
export var fieldCard = "_sd-1";
export var fieldDescription = "_sd-5";
export var fieldHeader = "_sd-3";
export var fieldTitle = "_sd-4";
export var finalNote = "_sd-s";
export var flow = "_sd-x";
export var flowArrow = "_sd-v";
export var flowStep = "_sd-u";
export var helperText = "_sd-r";
export var inlineTitle = "_sd-t";
export var listItem = "_sd-l";
export var noteBody = "_sd-8";
export var noteBodyText = "_sd-9";
export var noteCard = "_sd-2";
export var noteIcon = "_sd-6";
export var noteTitle = "_sd-7";
export var productChoices = "_sd-w";
export var radioDot = "_sd-d";
export var radioDotSelected = "_sd-e";
export var radioDotSvg = "_sd-f";
export var selectableCard = "_sd-b";
export var selectableCardSelected = "_sd-c";
export var strongText = "_sd-a";
export var subHeading = "_sd-0";